import React, { FC, ChangeEvent, FormEvent, MouseEvent } from "react";

import { Button, Form, FormSubmitButton } from "~/components/atoms";
import { LabelWithTextArea } from "~/components/molecules";

type PropsType = {
  context: {
    value: string;
    onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  };
  isSubmitting: boolean;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
  handleReadonly: (e: MouseEvent<HTMLButtonElement>) => void;
  handleNotReadonly: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  isReadOnly?: boolean;
};

export const AiCompanyContextForm: FC<PropsType> = ({
  context,
  isSubmitting,
  className,
  isReadOnly,
  handleSubmit,
  handleReadonly,
  handleNotReadonly,
}: PropsType) => {
  return (
    <Form className={`space-y-6 ${className}`} onSubmit={handleSubmit}>
      <LabelWithTextArea
        labelText="最新のAIカスタマイズ"
        name="context"
        placeholder="最新のAIカスタマイズ"
        rows={6}
        value={context.value}
        onChange={context.onChange}
        disabled={isReadOnly || isSubmitting}
      />
      <div className={`flex items-center space-x-4 w-full ${className}`}>
        {isReadOnly ? (
          <Button
            text="新しく投稿する"
            onClick={handleNotReadonly}
            color="gray"
            outline
            className="w-full"
          />
        ) : (
          <>
            <Button
              text="キャンセル"
              onClick={handleReadonly}
              color="gray"
              outline
              className="w-full"
            />
            <FormSubmitButton
              color="primary"
              value="投稿する"
              isReadOnly={isSubmitting}
              className="w-full"
            />
          </>
        )}
      </div>
    </Form>
  );
};
